export const COOKIE_NAMES = {
	XLTOVL_COOKIE: 'xlToVl',
};
